import React from 'react';
import { Link } from 'react-router-dom';
import './BrowseLinks.css';

const MODELS = [
  ['/innova-crysta-commercial-taxi-delhi', 'Innova Crysta taxis'],
  ['/dzire-commercial-taxi-delhi', 'Swift Dzire taxis'],
  ['/ertiga-commercial-taxi-delhi', 'Ertiga taxis'],
  ['/fortuner-commercial-taxi-delhi', 'Fortuner taxis'],
];
const MORE = [
  ['/sell-taxi', 'Sell your taxi'],
  ['/taxi-valuation', 'Taxi valuation calculator'],
  ['/t-permit', 'T-Permit guide'],
];

const cap = (slug) => slug.charAt(0).toUpperCase() + slug.slice(1);

/**
 * Body links to the commercial pages — city pages, model hubs, the main tools.
 *
 * An internal-link audit (2026-09-30) found the pages that sell were linked
 * almost only from the header and footer: the homepage body linked to none of
 * them, /vehicles linked to nothing but listings and its own pagination, and a
 * city page linked to no other city, no model hub and not even the permit
 * guide for its own state.
 *
 * `cities` is passed in (indexable slugs from CITY_SEO) rather than imported,
 * because CityLanding renders this component and owns CITY_SEO.
 *
 * @param {string[]} cities   indexable city slugs
 * @param {string}   [exclude] the current city's slug, left out of the row
 * @param {Array}    [extra]   [to, label] pairs added to the "More" row
 */
const BrowseLinks = ({ cities, exclude, extra = [], heading = 'Browse Used Taxis' }) => (
  <section className="browse-links" data-testid="browse-links">
    <h2>{heading}</h2>
    <div className="browse-row">
      <span className="browse-label">By city</span>
      {cities.filter((slug) => slug !== exclude).map((slug) => (
        <Link key={slug} to={`/buy-taxi-${slug}`} className="browse-chip">
          Used taxis in {cap(slug)}
        </Link>
      ))}
    </div>
    <div className="browse-row">
      <span className="browse-label">By model</span>
      {MODELS.map(([to, name]) => (
        <Link key={to} to={to} className="browse-chip">{name}</Link>
      ))}
    </div>
    <div className="browse-row">
      <span className="browse-label">More</span>
      {[...extra, ...MORE].map(([to, name]) => (
        <Link key={to} to={to} className="browse-chip">{name}</Link>
      ))}
    </div>
  </section>
);

export default BrowseLinks;
